<script>
import { mapGetters } from "vuex";
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  mounted() {
    
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgroundColor /* [
              "rgba(65, 184, 131, .8)",
              "rgba(228, 102, 81, .8)",
              "rgba(0, 216, 255, .8)",
              "rgba(155, 89, 182, .8)"
            ] */,
            borderWidth: 0,
            data: this.data /* [40, 20, 80, 10] */
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  },
  props: {
    data: Array,
    backgroundColor: Array,
    labels: Array
  }
};
</script>